import gym from './gym';

const menuItems = { items: [gym] };

export default menuItems;
